import React, { useEffect } from 'react';
import * as firebase from 'firebase/app';
import { getFirebaseApp } from '../utils/firebase';
import 'firebase/auth';
import * as firebaseui from 'firebaseui';
import 'firebaseui/dist/firebaseui.css';
import { Modal } from 'semantic-ui-react';
export var Login = function (_a) {
    var _b = _a.title, title = _b === void 0 ? 'You need to sign in to continue' : _b, onClose = _a.onClose;
    useEffect(function () {
        var uiConfig = {
            signInFlow: 'popup',
            // signInSuccessUrl: window.location.origin,
            signInSuccessUrl: window.location.href,
            signInOptions: [
                firebase.auth.GoogleAuthProvider.PROVIDER_ID,
            ],
        };
        // Initialize the FirebaseUI Widget using Firebase.
        var ui = new firebaseui.auth.AuthUI(getFirebaseApp().auth(), getFirebaseApp().name);
        // The start method will wait until the DOM is loaded.
        ui.start('#firebaseui-auth-container', uiConfig);
        return function () {
            ui.delete();
        };
    }, []);
    return (React.createElement(Modal, { closeIcon: true, size: "mini", open: true, onClose: onClose },
        React.createElement(Modal.Header, null, title),
        React.createElement(Modal.Content, null,
            React.createElement("div", { style: { margin: '3em 1.5em' } },
                React.createElement("div", { id: "firebaseui-auth-container" })))));
};
//# sourceMappingURL=Login.js.map